export default {
	name: "order-ex-tank-dashboard",
	data() {
		return {
			orders: [],
			orderStatuses: [],
			orderTypes: [],
			customers: [],
			report:{
				startDate: null,
				endDate: null
			},
			initialiseDatePicker: true,
			initialiseDatePickerEndDate: true,
			exTankOrderHeadings: [
				{
					text: "Order #",
					field: "orderId"
				},
				{
					text: "Customer",
					field: "registeredCompanyName"
				},
				{
					text: "Order Date",
					field: "insertedOn"
				},
				{
					text: "Expected Upliftment Date",
					field: "expectedUpliftmentDate"
				},
				{
					text: "Transporter",
					field: "transporter"
				},
				{
					text: "Vehicle Make",
					field: "vehicleMake"
				},
				{
					text: "Vehicle Registration",
					field: "vehicleRegistration"
				},
				{
					text: "Customer Purchase Order Number",
					field: "customerPurchaseOrder"
				},
				{
					text: "SBO",
					field: "sbo"
				},
				{
					text: "Product",
					field: "product"
				},
				{
					text: "Quantity",
					field: "quantity"
				},
				{
					text: "Amount Dispensed",
					field: "quantityDispensed"
				},
				{
					text: "Terminal",
					field: "terminal"
				},
				{
					text: "Total",
					field: "totalAsString"
				},
				{
					text: "Status",
					field: "orderStatus"
				}
			],
			apiLoaded:{
				customersLoaded: false,
				orderStatusesLoaded: false,
				orderTypesLoaded: false
			},
			actions: [],
			actionKeys:{
				viewOrder: "viewOrder",
				reviewOrder: "reviewOrder",
				viewTrackingHistory: "viewTrackingHistory",
				completeReview: "completeReview",
				cancel: "cancel",
				documents: "documents",
				completeOrder: "completeOrder",
				uploadBol: "uploadBol"
			},
			trackingHistoryModal:{
				showModal: false,
				isSaving: false,
				modalId: "trackingHistoryModal",
				heading: "Tracking History",
				orderId: null
			},
			filterStateChanged: false,
			showExpectedDateOfDeliveryFilter: true,
			filter:{
				fromDateCreated: null,
				toDateCreated: null,
				customerSearchQuery: null,
				activeOrInactiveItems: 1,
				orderTypeId: null,
				companyId: null,
				orderStatusId: null,
				expectedUpliftmentDateToDate: null,
				expectedUpliftmentFromDate: null
			},
			activeIsActiveKey:{
				active: 1,
				inactive: 0
			},
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			loading: false,
			selectedOrder: {},
			errorMessage: null,
		};
	},
	methods: {
		getExTankOrders(){
			this.loading = true;
			this.filter.orderTypeId = orderHelper.orderType.exTank;
			let request = {
				searchQuery: this.filter.customerSearchQuery,
				orderStatusId: this.filter.orderStatusId,
				fromDateCreated: this.filter.fromDateCreated,
				toDateCreated: this.filter.toDateCreated,
				pageNumber: this.pagingDetails.pageNumber,
				pageSize: this.pagingDetails.pageSize,
				fromDateExpectedUpliftment: this.filter.expectedUpliftmentFromDate,
				toDateExpectedUpliftment: this.filter.expectedUpliftmentDateToDate
			};
			exTankService.getExTankOrders(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.orders = successResponse.data.result;
						this.pagingDetails.pageNumber = successResponse.data.pagingInfo.thisPage;
						this.pagingDetails.totalPages = successResponse.data.pagingInfo.totalPages;
						for(let i = 0; i < this.orders.length; i++){
							if(this.orders[i].discountedAmount !== null){
								this.orders[i].totalAmount = this.orders[i].totalAmount - this.orders[i].discountedAmount;
							}
							// if(this.orders[i].orderTypeId === orderHelper.orderType.delivery){
							// 	this.orders[i].orderType = "Delivery";
							// }
							this.orders[i].totalAsString = currencyHelper.numberToCurrencyWithFourDecimalPlaces(this.orders[i].totalAmount);
							this.orders[i].actions = [
								{
									name: "View Order",
									key: this.actionKeys.viewOrder,
									elementId: "btnOrdersViewOrder"
								}
							];
						}
						this.orders = dataTableHelper.castFieldValues(this.orders);
						this.filterStateChanged = false;
						permissionsHelper.setControlsBasedOnPermissions();
						let self = this;
						setTimeout(function (){
							self.firstLoad = true;
						}, 500);
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getOrderStatuses(){
			this.firstLoad = false;
			console.log("order type", this.filter.orderTypeId);
			this.orderStatuses = orderService.getExTankOrderStatuses();
			//this.orderStatuses = orderService.getOrderStatuses();
			this.orderStatuses = $.map(this.orderStatuses,
				function (obj) {
					obj.id = obj.id || obj.orderStatusId;
					obj.text = obj.text || obj.description;
					return obj;
				});
			this.orderStatuses.unshift({
				id: 0,
				text: "All"
			});
			this.filter.orderStatusId = 0;
			this.apiLoaded.orderStatusesLoaded = true;
			// if(this.apiLoaded.orderTypesLoaded && this.apiLoaded.customersLoaded){
			// 	this.firstLoad = false;
			// }
			this.getExTankOrders();
			console.log("orderStatuses", this.orderStatuses);
		},
		onFilterSearchClicked(){
			this.pagingDetails = {
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			};
			this.getExTankOrders();
		},
		onOrderStatusSelect(orderStatus){
			this.filter.orderStatusId = orderStatus.id;
			if(this.firstLoad){
				this.filterStateChanged = true;
			}
		},
		onDateFilterClearClick(){
			console.log("clear clicked");
			this.filter.toDateCreated = null;
			this.filter.fromDateCreated = null;
			if(this.firstLoad){
				this.filterStateChanged = true;
			}
		},
		onToDateCreatedSelect(date){
			this.filter.toDateCreated = date;
			if(this.firstLoad){
				this.filterStateChanged = true;
			}
			console.log("filter", this.filter);
		},
		onFromDateCreatedSelect(date){
			this.filter.fromDateCreated = date;
			if(this.firstLoad){
				this.filterStateChanged = true;
			}
			console.log("filter", this.filter);
		},
		onExpectedUpliftmentFilterClearClick(){
			this.filter.expectedUpliftmentFromDate = null;
			this.filter.expectedUpliftmentDateToDate = null;
			if(this.firstLoad){
				this.filterStateChanged = true;
			}
		},
		onExpectedUpliftmentFromDateSelect(date){
			this.filter.expectedUpliftmentFromDate = date;
			if(this.firstLoad){
				this.filterStateChanged = true;
			}
		},
		onExpectedUpliftmentToDateSelect(date){
			this.filter.expectedUpliftmentDateToDate = date;
			if(this.firstLoad){
				this.filterStateChanged = true;
			}
		},

		onTrackingHistoryOkButtonClicked(){
			this.trackingHistoryModal.showModal = false;
		},
		onOrderActionClicked(actionAndData){
			console.log("actionAndData", actionAndData);
			switch(actionAndData.action){
				case this.actionKeys.viewOrder:
					this.$router.push("/orders/extank/viewOrder/" + actionAndData.data.orderExTankId + "/" + actionAndData.data.orderId);
					break;
				case this.actionKeys.viewTrackingHistory:
					this.trackingHistoryModal.showModal = true;
					this.trackingHistoryModal.orderId = actionAndData.data.orderId;
					this.trackingHistoryModal.heading = "Tracking History - #" + actionAndData.data.orderId + " (" + actionAndData.data.registeredCompanyName + ")";
					break;
			}
		},
		onFromReportDateSelect(date){
			this.report.startDate = date;
			this.initialiseDatePicker = false;
		},
		onToReportDateSelect(date){
			this.report.endDate = date;
			this.initialiseDatePickerEndDate = false;
		},
		checkReportDeliveryVarianceReport(){
			this.errorMessage = null;
			if(this.report.startDate === null || this.report.endDate === null){
				this.errorMessage = "Please select a date range";
				return;
			}
			this.loading = true;
			let request = {
				startDate: this.report.startDate,
				endDate: this.report.endDate
			};
			orderService.checkReportDeliveryVarianceReport(request).then(
				successResponse => {
					console.log("successResponse", successResponse);
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						if(successResponse.data.hasError){
							this.errorMessage = successResponse.data.message;
						}
						else{
							this.downloadReportDeliveryVarianceReport();
						}
						this.loading = false;
					}
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		downloadReportDeliveryVarianceReport(){
			this.errorMessage = null;
			if(this.report.startDate === null || this.report.endDate === null){
				this.errorMessage = "Please select a date range";
				return;
			}
			this.loading = true;
			let request = {
				startDate: this.report.startDate,
				endDate: this.report.endDate
			};
			orderService.downloadReportDeliveryVarianceReport(request).then(
				successResponse => {
					console.log("successResponse", successResponse);
					const url = window.URL.createObjectURL(new Blob([successResponse.data]));
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', "DeliveryVarianceReport.xlsx");
					document.body.appendChild(link);
					link.click();
					this.loading = false;
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		checkReportExTankDispenseVarianceReport(){
			this.errorMessage = null;
			if(this.report.startDate === null || this.report.endDate === null){
				this.errorMessage = "Please select a date range";
				return;
			}
			this.loading = true;
			let request = {
				startDate: this.report.startDate,
				endDate: this.report.endDate
			};
			orderService.checkReportExTankDispenseVarianceReport(request).then(
				successResponse => {
					console.log("successResponse", successResponse);
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						if(successResponse.data.hasError){
							this.errorMessage = successResponse.data.message;
						}
						else{
							this.downloadReportExTankDispenseVarianceReport();
						}
						this.loading = false;
					}
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		downloadReportExTankDispenseVarianceReport(){
			this.errorMessage = null;
			if(this.report.startDate === null || this.report.endDate === null){
				this.errorMessage = "Please select a date range";
				return;
			}
			this.loading = true;
			let request = {
				startDate: this.report.startDate,
				endDate: this.report.endDate
			};
			orderService.downloadReportExTankDispenseVarianceReport(request).then(
				successResponse => {
					console.log("successResponse", successResponse);
					const url = window.URL.createObjectURL(new Blob([successResponse.data]));
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', "ExTankDispenseVarianceReport.xlsx");
					document.body.appendChild(link);
					link.click();
					this.loading = false;
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		}
	},
	mounted: function () {
		storeState.setPageTitleAction("Recent Orders - Ex-Tank");
		breadcrumbsStoreState.setRootBreadcrumb(this.$route.path, "Recent Orders - Ex-Tank");
		this.getOrderStatuses();
	}
};